import { useLayoutEffect, useState, RefObject } from 'react'

export const useElementWidth = <T extends HTMLElement = HTMLElement>(
    elementRef: RefObject<T>
) => {
    const [width, setWidth] = useState<number>()

    useLayoutEffect(() => {
        const element = elementRef.current
        if (!element) return

        // Calculate content width
        const style = getComputedStyle(element)
        const rect = element.getBoundingClientRect()
        const padding =
            parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
        const border =
            parseFloat(style.borderLeftWidth) +
            parseFloat(style.borderRightWidth)

        setWidth(rect.width - padding - border)

        const observer = new ResizeObserver(([entry]) => {
            setWidth(entry.contentRect.width)
        })

        observer.observe(element)
        return () => {
            observer.disconnect()
        }
    }, [elementRef])

    return width
}
